import { useCompanySettings } from '../../../company-settings/api/use-company-settings';

export const useWarningSignalsVisible = (): boolean => {
    const { data: companySettings } = useCompanySettings();
    return companySettings?.warningSignalsVisible ?? true;
};
